// extracted by mini-css-extract-plugin
var _1 = "TopbarCreatePostButton-module__animatedBackground--j6dTV";
var _2 = "TopbarCreatePostButton-module__container--rsKgJ";
var _3 = "TopbarCreatePostButton-module__dropdownButton--jEq6m";
var _4 = "TopbarCreatePostButton-module__mainButton--APzQE";
export { _1 as "animatedBackground", _2 as "container", _3 as "dropdownButton", _4 as "mainButton" }
